export default __webpack_public_path__ + "static/media/il-borgo-gallery-3-morelli-remigio.fbb5d904.jpg";